import { render, staticRenderFns } from "./PopupImageComponent.vue?vue&type=template&id=2499a71f&scoped=true&"
import script from "./PopupImageComponent.vue?vue&type=script&lang=js&"
export * from "./PopupImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./PopupImageComponent.vue?vue&type=style&index=0&id=2499a71f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2499a71f",
  null
  
)

export default component.exports